var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tootip-box"},[_c('el-popover',{attrs:{"placement":"top-start","trigger":"hover","content":_vm.item.tooTip.content}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"tooTip",class:[
          _vm.item.tooTip.iconClass ? _vm.item.tooTip.iconClass : 'el-icon-info',
        ]})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }